import Fighting from '@/classes/character/fighting';
import { Category } from '@/classes/character/allValues';
import { Modifier } from './modifier';
import BaseAttribute from '../attributes/baseAttribute';
import Resource from '../attributes/resource';
import BaseAttributeCollection from '../attributes/baseAttributeCollection';
import ValueAttribute from '../attributes/valueAttribute';
import DiceAttribute from '../attributes/diceAttribute';

export default class Character {
  public name: string | null = null;
  public class: string | null = null;
  public race: string | null = null;
  private fighting: Fighting;
  private values: BaseAttribute[] = [];
  private finalValues: BaseAttribute[] = [];
  private modifiers: Modifier[] = [
    new Modifier('ep', 100, 'Kampf 1'),
    new Modifier('ep', 500, 'Kampf 2'),
    new Modifier('aip', 10, 'Erstellung'),
  ];

  public constructor() {
    this.fighting = new Fighting();
  }

  public init() {
    this.values = [];
    const baseAttributeCollection = new BaseAttributeCollection();
    this.values.push(...baseAttributeCollection.baseResources);
    this.values.push(...baseAttributeCollection.baseDiceAttributes);
    this.values.push(...baseAttributeCollection.baseElements);
  }

  public getValueByAbbreviation(abbreviation: string): ValueAttribute {
    return this.findValueByAbbreviation(abbreviation) as ValueAttribute;
  }

  public getFinalValueByAbbreviation(abbreviation: string): ValueAttribute {
    // It is nescessary to create a fresh attribute so that vue doesn't update the value endlessly
    const value: BaseAttribute = this.findValueByAbbreviation(abbreviation);

    const clone = value.getClone();
    if (clone instanceof ValueAttribute) {
      const modifierValue = this.getTotalModifierValueByType(abbreviation);
      clone.value += modifierValue;
    }
    return clone;
  }

  public setValueByAbbreviation(abbreviation: string, value: number) {
    const foundValueRaw: BaseAttribute = this.findValueByAbbreviation(
      abbreviation,
    );

    if (!(foundValueRaw instanceof ValueAttribute)) {
      throw new Error(
        'Found value for "' + abbreviation + '" is no ValueAttribute',
      );
    }

    const foundValue: ValueAttribute = foundValueRaw as ValueAttribute;
    foundValue.value = value;
  }

  public getFinalBlockValues() {
    const armorInitiativeBlock: number = this.fighting.getTotalInitiativeBlock();
    const armorSlotBlock: number = this.fighting.getTotalSlotBlock();

    // Substract the
    const armorKnowledge = this.getValueByAbbreviation('ruestungskunde');
  }

  public getTotalModifierValueByType(type: string): number {
    let totalValue: number = 0;
    this.modifiers
      .filter((modifier) => modifier.modifiingValueName === type)
      .forEach((modifier) => {
        totalValue += modifier.modifiingValue;
      });

    return totalValue;
  }

  private findValueByAbbreviation(abbreviation: string): BaseAttribute {
    const matchingValue = this.values.filter(
      (localValue) => localValue.abbreviation === abbreviation,
    );

    if (matchingValue.length === 0) {
      throw new Error('Value not found ' + abbreviation);
    }

    if (matchingValue.length !== 1) {
      throw new Error('More than one value found for ' + abbreviation);
    }

    return matchingValue[0];
  }
}
